var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegendScore2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 42,
    viewBox: "0 0 130 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5104_4199",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H129.5V42H0.5V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 42.75H8.5625V41.25H0.5V42.75ZM24.6875 42.75H40.8125V41.25H24.6875V42.75ZM56.9375 42.75H73.0625V41.25H56.9375V42.75ZM89.1875 42.75H105.312V41.25H89.1875V42.75ZM121.438 42.75H129.5V41.25H121.438V42.75ZM129.5 -0.75H121.438V0.75H129.5V-0.75ZM105.312 -0.75H89.1875V0.75H105.312V-0.75ZM73.0625 -0.75H56.9375V0.75H73.0625V-0.75ZM40.8125 -0.75H24.6875V0.75H40.8125V-0.75ZM8.5625 -0.75H0.5V0.75H8.5625V-0.75ZM0.5 43.5H8.5625V40.5H0.5V43.5ZM24.6875 43.5H40.8125V40.5H24.6875V43.5ZM56.9375 43.5H73.0625V40.5H56.9375V43.5ZM89.1875 43.5H105.312V40.5H89.1875V43.5ZM121.438 43.5H129.5V40.5H121.438V43.5ZM129.5 -1.5H121.438V1.5H129.5V-1.5ZM105.312 -1.5H89.1875V1.5H105.312V-1.5ZM73.0625 -1.5H56.9375V1.5H73.0625V-1.5ZM40.8125 -1.5H24.6875V1.5H40.8125V-1.5ZM8.5625 -1.5H0.5V1.5H8.5625V-1.5Z",
    fill: "#00ED50",
    mask: "url(#path-1-inside-1_5104_4199)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendScore2);
export default __webpack_public_path__ + "static/media/legend-score-2.ec9d84331c47074916fc526929b6aac7.svg";
export { ForwardRef as ReactComponent };